import { sortDevices, allTemplateNonConformities, expandReference, unique, templateDeviceValue, deviceSubstitutionStatus  } from './utils'; 

export const offerTableData = (data) => {
    //console.log("aushdiwuehdewiuh", data)
    const customerProducts = data
    const sortDevicesBy = "Posizione"
    const customerProductDoc = (cP) => {
        const {
            _id,
            nonConformity,
            customerProduct,
            pricelistCode,
            law,
            lawLabel,
            description,
            location,
            quantity,
            unitPrice,
            discountedUnitPrice,
            priceToClient,
            discount,
            supplierPrice,
            totalCost,
            margin,
            profit,
            unitProfit,
            allowZero,
            labourProduct
        } = cP
        
        const doc = {
            _id, nonConformity, labourProduct, allowZero, discountedUnitPrice, customerProduct, pricelistCode, law, lawLabel, description, location, quantity, unitPrice, priceToClient, discount, supplierPrice, totalCost, margin, profit, unitProfit,
        }
        return doc

    }
    const tableDataArray = !customerProducts ? [] : customerProducts
    ?.map?.((item => {
        const array =  [  
            [{Header:"ID", accessor:"_id", value: customerProductDoc(item)?._id,},], 
            [{Header:"NON CONFORMITA'", accessor:"nonConformity", value: customerProductDoc(item)?.nonConformity}], 
            [{Header:"PRODOTTO", accessor:"customerProduct", value: customerProductDoc(item)?.customerProduct}], 
            [{Header:"COD.", accessor:"pricelistCode", value: customerProductDoc(item)?.pricelistCode, order: 1}],
            [{Header: "NORMATIVA DI RIFERIMENTO PER L'ADEMPIMENTO AGLI OBBLIGHI DEI PRESIDI ATTREZZATURE E SISTEMI", accessor:"law", value: customerProductDoc(item)?.law, minWidth:50, valueType: "RICHEDITOR"}],
            [{Header: "NORMATIVA DI RIFERIMENTO PER L'ADEMPIMENTO AGLI OBBLIGHI DEI PRESIDI ATTREZZATURE E SISTEMI", accessor:"lawLabel", value: customerProductDoc(item)?.lawLabel, minWidth:50}],
            [{Header: "DESCRIZIONE", accessor:"description", value: customerProductDoc(item)?.description, minWidth:70, valueType: "RICHEDITOR"}],
            [{Header: "UBICAZIONE", accessor:"location", value: customerProductDoc(item)?.location}],
            [{Header: "Q.TA’", accessor:"quantity", value: customerProductDoc(item)?.quantity,  valueType: "TWODECIMALS", labourProduct: customerProductDoc(item)?.labourProduct}],
            [{Header: "PREZZO CAD.", accessor:"unitPrice", value: +customerProductDoc(item)?.unitPrice, valueType: "CURRENCY"}],
            [{Header: "SCONTO %", accessor:"discount", value: +customerProductDoc(item)?.discount, valueType: "PERCENTAGE"}],
            [{Header: "PREZZO CAD. SCONTATO", accessor:"discountedUnitPrice", value: +customerProductDoc(item)?.discountedUnitPrice, valueType: "CURRENCY"}],
            [{Header: "TOTALE", accessor:"priceToClient", value: +customerProductDoc(item)?.priceToClient, valueType: "CURRENCY"}],
            [{Header: "PREZZO FORNITORE", accessor:"supplierPrice", value: +customerProductDoc(item)?.supplierPrice, valueType: "CURRENCY",isCost:true}],
            [{Header: "TOTALE COSTO", accessor:"totalCost", value: +customerProductDoc(item)?.totalCost, valueType: "CURRENCY", isCost:true}],
            [{Header: "MARGINE", accessor:"margin", value: +customerProductDoc(item)?.margin, valueType: "PERCENTAGE",isCost:true}],
            [{Header: "PROFITTO", accessor:"profit", value: +customerProductDoc(item)?.profit, valueType: "CURRENCY",isCost:true}],
            [{Header: "PROFITTO CAD.", accessor:"unitProfit", value: +customerProductDoc(item)?.unitProfit, valueType: "CURRENCY",isCost:true}],
            [{Header:"ZERO", accessor:"allowZero", value: customerProductDoc(item)?.allowZero}], 
            [{Header:"LABOUR PRODUCT", accessor:"labourProduct", value: customerProductDoc(item)?.labourProduct}], 
        ] 
        return array
    })) 

    return tableDataArray
}